import { render } from "./topicManagerInfo.vue?vue&type=template&id=7522536e&scoped=true"
import script from "./topicManagerInfo.vue?vue&type=script&lang=js"
export * from "./topicManagerInfo.vue?vue&type=script&lang=js"

import "./topicManagerInfo.vue?vue&type=style&index=0&id=7522536e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7522536e"]])

export default __exports__